module.exports = __webpack_public_path__ + "715ae3663b506eb5a10b0a457cbe3e3d.svg";


//////////////////
// WEBPACK FOOTER
// ./images/trash-blue.svg
// module id = 75
// module chunks = 0